<template>
  <!-- <Main></Main> -->
  <router-view />
</template>

<style>
@import "./core/styles/global.css"
</style>
